import styled from 'styled-components'

export default styled.div`
  font-family: montserrat;
`



// WEBPACK FOOTER //
// ./src/components/organisms/JSONViewerPane/SubTitle.js